/* Art-is-Artis v18 — header, search, drawer, product form, cart toast, analytics hooks.
   No dependencies. Loaded with `defer`. */
(function () {
  'use strict';

  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var T = window.AIA_STRINGS || {};

  /* ---------------------------------------------------------------------
     Analytics: custom events go to Shopify's Customer Events (Web Pixels).
     Standard e-commerce events (product viewed, added to cart, checkout,
     purchase, search) are already emitted by Shopify itself, so we do NOT
     re-send them here — that is what prevents double counting in GA4/Meta.
     Subscribe in Settings → Customer events → custom pixel:
       analytics.subscribe('aia_cta_click', e => …)
  --------------------------------------------------------------------- */
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) { /* never break the page for analytics */ }
  }
  window.aiaTrack = track;

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track]');
    if (el) track('aia_cta_click', { id: el.getAttribute('data-track'), href: el.getAttribute('href') || '', page: location.pathname });
    var card = e.target.closest('[data-aia-item]');
    if (card && e.target.closest('a')) {
      track('aia_select_item', {
        item_id: card.getAttribute('data-item-id'),
        item_name: card.getAttribute('data-item-name'),
        item_category: card.getAttribute('data-item-cat'),
        item_list_name: card.getAttribute('data-list'),
        index: Number(card.getAttribute('data-pos') || 0)
      });
    }
  });

  /* view_item_list: one event per visible list */
  if ('IntersectionObserver' in window) {
    var seenLists = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var list = en.target.getAttribute('data-aia-list');
        if (seenLists[list]) return;
        seenLists[list] = true;
        var items = qsa('[data-aia-item]', en.target).map(function (c, i) {
          return { item_id: c.getAttribute('data-item-id'), item_name: c.getAttribute('data-item-name'), index: i + 1 };
        });
        track('aia_view_item_list', { item_list_name: list, items: items });
        io.unobserve(en.target);
      });
    }, { threshold: 0.3 });
    qsa('[data-aia-list]').forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------
     Header mega menus
  --------------------------------------------------------------------- */
  var nav = qs('[data-aia-nav]');
  if (nav) {
    var items = qsa('.aia-nav__item', nav);
    var closeAll = function (except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var b = qs('.aia-nav__top', it); if (b) b.setAttribute('aria-expanded', 'false');
      });
    };
    var hoverCapable = window.matchMedia('(hover: hover)').matches;
    items.forEach(function (it) {
      var btn = qs('.aia-nav__top', it);
      var timer;
      var open = function () { closeAll(it); it.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
      var close = function () { it.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); };
      btn.addEventListener('click', function () { it.classList.contains('is-open') ? close() : open(); });
      if (hoverCapable) {
        it.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(open, 80); });
        it.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(close, 180); });
      }
      it.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); btn.focus(); }
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-aia-nav]')) closeAll(); });
  }

  /* ---------------------------------------------------------------------
     Mobile drawer
  --------------------------------------------------------------------- */
  var drawer = qs('[data-aia-drawer]');
  var drawerOpenBtn = qs('[data-aia-drawer-open]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('aia-lock', open);
    if (drawerOpenBtn) drawerOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var f = qs('summary, a, button', qs('.aia-drawer__panel', drawer)); if (f) f.focus(); }
    else if (drawerOpenBtn) drawerOpenBtn.focus();
  }
  if (drawer && drawerOpenBtn) {
    drawerOpenBtn.addEventListener('click', function () { setDrawer(true); });
    qsa('[data-aia-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
      if (e.key === 'Tab') { /* simple focus trap */
        var f = qsa('a, button, summary, select, input', qs('.aia-drawer__panel', drawer)).filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
  }

  /* ---------------------------------------------------------------------
     Predictive search (Shopify native endpoint + section rendering)
  --------------------------------------------------------------------- */
  var sToggle = qs('[data-aia-search-toggle]');
  var sPanel = qs('[data-aia-search]');
  var sInput = qs('[data-aia-search-input]');
  var sResults = qs('[data-aia-search-results]');
  if (sToggle && sPanel && sInput) {
    sToggle.addEventListener('click', function () {
      var open = !sPanel.classList.contains('is-open');
      sPanel.classList.toggle('is-open', open);
      sToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) setTimeout(function () { sInput.focus(); }, 30);
    });
    sPanel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { sPanel.classList.remove('is-open'); sToggle.setAttribute('aria-expanded', 'false'); sToggle.focus(); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var opts = qsa('[role="option"]', sResults); if (!opts.length) return;
        e.preventDefault();
        var cur = opts.indexOf(document.activeElement);
        var next = e.key === 'ArrowDown' ? Math.min(cur + 1, opts.length - 1) : Math.max(cur - 1, -1);
        if (next === -1) sInput.focus(); else opts[next].focus();
      }
    });
    var timer, ctrl;
    sInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = sInput.value.trim();
      if (q.length < 2) { sResults.innerHTML = ''; sInput.setAttribute('aria-expanded', 'false'); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = (sInput.getAttribute('data-url') || '/search/suggest') + '?q=' + encodeURIComponent(q) +
          '&section_id=aia-predictive-search&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag,vendor';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = qs('#shopify-section-aia-predictive-search', doc) || doc.body;
            sResults.innerHTML = inner.innerHTML;
            sInput.setAttribute('aria-expanded', 'true');
            track('aia_search_typed', { q: q });
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------------------------------------------------------------------
     Cart helpers
  --------------------------------------------------------------------- */
  function updateCartCount(count) {
    qsa('[data-aia-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  window.aiaUpdateCartCount = updateCartCount;

  /* ---------------------------------------------------------------------
     Product form (wearable art template)
  --------------------------------------------------------------------- */
  qsa('[data-aia-product]').forEach(function (root) {
    var dataEl = qs('[data-aia-product-json]', root);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var form = qs('form[action*="/cart/add"]', root);
    var idInput = qs('input[name="id"]', form);
    var priceEl = qs('[data-aia-price]', root);
    var addBtn = qs('[data-aia-add]', root);
    var statusEl = qs('[data-aia-status]', root);
    var stickyBtn = qs('[data-aia-sticky-add]');
    var stickyPrice = qs('[data-aia-sticky-price]');
    var stickyVariant = qs('[data-aia-sticky-variant]');
    var optionInputs = qsa('[data-aia-option]', root);
    var optCount = (data.options || []).length;

    function selectedOptions() {
      var sel = [];
      for (var i = 0; i < optCount; i++) {
        var group = optionInputs.filter(function (n) { return Number(n.getAttribute('data-index')) === i; });
        var val = null;
        group.forEach(function (n) {
          if (n.tagName === 'SELECT') val = n.value;
          else if (n.checked) val = n.value;
        });
        sel.push(val);
      }
      return sel;
    }
    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function refreshAvailability(sel) {
      /* mark values that cannot be combined with the other current choices */
      optionInputs.forEach(function (n) {
        var idx = Number(n.getAttribute('data-index'));
        var test = sel.slice();
        if (n.tagName === 'SELECT') {
          qsa('option', n).forEach(function (o) {
            test[idx] = o.value;
            var v = findVariant(test);
            o.textContent = o.getAttribute('data-label') + (v && v.available ? '' : ' — ' + (T.unavailable || 'Unavailable'));
          });
          return;
        }
        test[idx] = n.value;
        var v = findVariant(test);
        var pill = n.nextElementSibling;
        if (pill) pill.classList.toggle('is-unavailable', !(v && v.available));
      });
      qsa('[data-aia-selected-value]', root).forEach(function (el) {
        var idx = Number(el.getAttribute('data-aia-selected-value'));
        el.textContent = sel[idx] || '';
      });
    }
    function showMediaFor(v) {
      if (!v || !v.featured_media) return;
      var thumb = qs('[data-media-id="' + v.featured_media.id + '"]', root);
      if (thumb) thumb.click();
    }
    function apply(fromUser) {
      var sel = selectedOptions();
      var v = findVariant(sel);
      refreshAvailability(sel);
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = T.unavailable || 'Unavailable';
        if (statusEl) { statusEl.textContent = T.combo || ''; statusEl.classList.add('is-error'); }
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (stickyPrice) stickyPrice.innerHTML = v.price_html;
      if (stickyVariant) stickyVariant.textContent = v.title === 'Default Title' ? '' : v.title;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? (T.add || 'Add to bag') : (T.soldOut || 'Sold out');
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = addBtn.textContent; }
      if (statusEl) { statusEl.textContent = ''; statusEl.classList.remove('is-error'); }
      if (fromUser) {
        showMediaFor(v);
        try {
          var url = new URL(location.href); url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }
    optionInputs.forEach(function (n) { n.addEventListener('change', function () { apply(true); }); });
    apply(false);

    /* quantity stepper */
    var qty = qs('[data-aia-qty]', root);
    qsa('[data-aia-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.getAttribute('data-aia-qty-step')));
        qty.value = n;
      });
    });

    /* AJAX add to cart with graceful fallback to normal form post */
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var label = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = T.adding || '…';
      var body = new FormData(form);
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: body
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          addBtn.disabled = false; addBtn.textContent = label;
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message));
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); })
            .then(function (cart) { updateCartCount(cart.item_count); openToast(res.j); });
        })
        .catch(function (err) {
          addBtn.disabled = false; addBtn.textContent = label;
          if (statusEl) { statusEl.textContent = (err && err.message) || T.error || 'Error'; statusEl.classList.add('is-error'); }
        });
    });

    /* sticky bar on mobile */
    var sticky = qs('[data-aia-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(addBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }

    /* size guide dialog */
    var sgBtn = qs('[data-aia-sizeguide-open]', root);
    var sg = qs('[data-aia-sizeguide]', root);
    if (sgBtn && sg && sg.showModal) {
      sgBtn.addEventListener('click', function () { sg.showModal(); track('aia_size_guide_open', { product: data.handle }); });
      qsa('[data-aia-dialog-close]', sg).forEach(function (b) { b.addEventListener('click', function () { sg.close(); }); });
      sg.addEventListener('click', function (e) { if (e.target === sg) sg.close(); });
    } else if (sgBtn && sg) {
      sgBtn.style.display = 'none';
    }
  });

  /* ---------------------------------------------------------------------
     Gallery (thumbs, arrows, swipe, lightbox via theme.js [data-lightbox-src])
  --------------------------------------------------------------------- */
  qsa('[data-aia-gallery]').forEach(function (g) {
    var main = qs('[data-aia-gallery-main]', g);
    var img = qs('img', main);
    var thumbs = qsa('[data-aia-thumb]', g);
    var count = qs('[data-aia-gallery-count]', g);
    var idx = 0;
    function show(i) {
      if (!thumbs.length) return;
      idx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      img.src = t.getAttribute('data-src');
      img.srcset = t.getAttribute('data-srcset') || '';
      img.alt = t.getAttribute('data-alt') || '';
      main.setAttribute('data-lightbox-src', t.getAttribute('data-zoom'));
      var frame = main.parentNode; if (frame) frame.classList.toggle('is-art', t.hasAttribute('data-art'));
      main.setAttribute('data-lightbox-alt', t.getAttribute('data-alt') || '');
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      if (count) count.textContent = (idx + 1) + ' / ' + thumbs.length;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = qs('[data-aia-gallery-prev]', g), next = qs('[data-aia-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    var x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { show(idx + (dx < 0 ? 1 : -1)); }
      x0 = null;
    });
  });

  /* ---------------------------------------------------------------------
     Added-to-bag toast
  --------------------------------------------------------------------- */
  function openToast(item) {
    var toast = qs('[data-aia-toast]');
    if (!toast) { location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; return; }
    var row = qs('[data-aia-toast-row]', toast);
    var imgUrl = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
    row.innerHTML = '';
    if (imgUrl) { var im = document.createElement('img'); im.src = imgUrl + (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=160'; im.alt = ''; row.appendChild(im); }
    var txt = document.createElement('div');
    var strong = document.createElement('strong'); strong.textContent = item.product_title; txt.appendChild(strong);
    if (item.variant_title) { var s = document.createElement('div'); s.textContent = item.variant_title; txt.appendChild(s); }
    row.appendChild(txt);
    toast.classList.add('is-open');
    var close = qs('[data-aia-toast-close]', toast);
    if (close) close.focus();
    clearTimeout(openToast._t);
    openToast._t = setTimeout(function () { toast.classList.remove('is-open'); }, 9000);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-aia-toast-close]')) { var t = qs('[data-aia-toast]'); if (t) t.classList.remove('is-open'); }
  });
})();

/* v18.1 — hero painting slideshow */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Array.prototype.forEach.call(document.querySelectorAll('[data-aia-slideshow]'), function (stage) {
    var slides = stage.querySelectorAll('[data-aia-slide]');
    if (slides.length < 2) return;
    var ms = Number(stage.getAttribute('data-interval')) || 6000;
    var i = 0, timer = null, paused = reduce, hover = false;
    var btn = stage.querySelector('[data-aia-slideshow-toggle]');
    function show(n) {
      slides[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(slides[i].querySelectorAll('a'), function (a) { a.setAttribute('tabindex', '-1'); });
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
      Array.prototype.forEach.call(slides[i].querySelectorAll('a'), function (a) { a.removeAttribute('tabindex'); });
    }
    function tick() { if (!paused && !hover && !document.hidden) show(i + 1); }
    function start() { clearInterval(timer); timer = setInterval(tick, ms); }
    function setPaused(p) {
      paused = p;
      if (btn) {
        btn.classList.toggle('is-paused', p);
        btn.setAttribute('aria-label', btn.getAttribute(p ? 'data-label-play' : 'data-label-pause'));
      }
    }
    /* the mouse no longer pauses the slideshow (owner feedback); keyboard focus still does */
    stage.addEventListener('focusin', function (e) { if (!e.target.closest('[data-aia-slideshow-prev],[data-aia-slideshow-next]')) hover = true; });
    stage.addEventListener('focusout', function () { hover = false; });
    if (btn) btn.addEventListener('click', function () { setPaused(!paused); });
    var prevB = stage.querySelector('[data-aia-slideshow-prev]'), nextB = stage.querySelector('[data-aia-slideshow-next]');
    if (prevB) prevB.addEventListener('click', function () { show(i - 1); start(); });
    if (nextB) nextB.addEventListener('click', function () { show(i + 1); start(); });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); start(); }
    });
    setPaused(paused);
    start();
  });
})();

/* v18.2 — story video lightbox (YouTube, loaded on click) */
(function () {
  'use strict';
  var dlg;
  function ensure() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'aia-dialog aia-dialog--video';
    dlg.innerHTML = '<div class="aia-dialog__head"><strong></strong><button class="aia-tool" type="button" aria-label="Close">&times;</button></div><div class="aia-video"></div>';
    document.body.appendChild(dlg);
    dlg.querySelector('button').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () { dlg.querySelector('.aia-video').innerHTML = ''; });
    return dlg;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-aia-video]');
    if (!b) return;
    var id = b.getAttribute('data-aia-video');
    if (!id) return;
    var d = ensure();
    if (!d.showModal) { window.open('https://www.youtube.com/watch?v=' + encodeURIComponent(id), '_blank'); return; }
    var t = b.querySelector('strong');
    d.querySelector('.aia-dialog__head strong').textContent = t ? t.textContent : '';
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    f.title = t ? t.textContent : 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture';
    f.allowFullscreen = true;
    var box = d.querySelector('.aia-video'); box.classList.toggle('aia-video--vertical', b.hasAttribute('data-vertical')); d.classList.toggle('aia-dialog--vertical', b.hasAttribute('data-vertical'));
    box.appendChild(f);
    d.showModal();
    if (window.aiaTrack) window.aiaTrack('aia_story_video_play', { video: id, page: location.pathname });
  });
})();
